import { GATEWAY_API_URL } from '@admin-panel/config/env';

export type InventoryType = 'GOOD_INVENTORY' | 'BAD_INVENTORY';
/** INFLUENCER is shown as "B2B Party": influencers, dry cleaners and other B2B customers. */
export type OnDemandType = 'STOCK_TRANSFER' | 'RTV' | 'INFLUENCER';

export const PURPOSE_MAX_LENGTH = 255;

export const onDemandTypeTag = (t?: OnDemandType) =>
  t === 'RTV' ? 'RTV' : t === 'INFLUENCER' ? 'B2B Party' : undefined;

/** One shelf/stock-type the scanned SKU can be booked from. Backend sorts GOOD first, most units first. */
export interface IShelfOption {
  shelfCode: string;
  section?: string;
  inventoryType: InventoryType;
  available: number;
}

export interface IOnDemandShelfOptions {
  skuCode: string;
  barcode?: string;
  name?: string;
  brand?: string;
  color?: string;
  size?: string;
  imageUrl?: string;
  /** false when shelf data could not be read at all (vs. read, but the SKU is on no shelf). */
  suggestionsAvailable: boolean;
  options: IShelfOption[];
}

/** One booked row: units of a SKU taken from one shelf as one stock type. */
export interface IOnDemandLine {
  skuCode: string;
  name?: string;
  brand?: string;
  color?: string;
  size?: string;
  imageUrl?: string;
  shelfCode: string;
  inventoryType: string;
  quantity: number;
  /**
   * Who added these units (user ids), most first, with when each unit was picked on (newest first; empty when
   * unknown). Older SCM builds leave them out.
   */
  addedBy?: Array<{ userId: string; quantity: number; addedOn?: string[] }>;
}

export interface IOnDemandGatepass {
  gatepassId: number;
  gatepassCode: string;
  unicomGatepassCode: string;
  unicomGatepassStatus: 'CREATED' | 'RETURN_AWAITED' | 'CLOSED' | 'DISCARDED';
  stockTransferId: number;
  stnRequestNumber: string;
  gatepassOrderId: number;
  gatepassOrderCode: string;
  type: OnDemandType;
  fromFacilityId: number;
  toFacilityId: number;
  destinationLabel: string;
  b2bCustomerId?: number;
  purpose?: string;
  createdBy?: string;
  createdOn?: string;
  totalScanned: number;
  /** SCM's time when this answer was built: pick times are aged against it, never against the phone's clock. */
  asOf?: string;
  lines: IOnDemandLine[];
}

export const onDemandUrl = (path = '') => `${GATEWAY_API_URL}/wms/gatepass/on-demand${path}`;

export const inventoryTypeLabel = (t?: string) => (t === 'BAD_INVENTORY' ? 'Bad' : 'Good');
